import { Injectable } from '@angular/core'

interface AppIdException {
  fileName: string
  appId: string
}

const appIdExceptions: AppIdException[] = [
  {
    fileName: 'conceptmapper',
    appId: 'cm2',
  },
  {
    fileName: 'dataSetEditor',
    appId: 'dataSetEditor3',
  },
  {
    fileName: 'dataSetViewer',
    appId: 'dataSetViewer3',
  },
  {
    fileName: 'geogebra',
    appId: 'geoGebraWrapper',
  },
  {
    fileName: 'quizTool',
    appId: 'quizTool',
  },
  {
    fileName: 'quizApp',
    appId: 'Quiz2',
  },
  {
    fileName: 'questionnaireApp',
    appId: 'Questionnaire2',
  },
  {
    fileName: 'timespent',
    appId: 'reflect3',
  },
  {
    fileName: 'padlet',
    appId: 'padletWrapper',
  },
  {
    fileName: 'scratch',
    appId: 'scratchWrapper',
  },
]

@Injectable({
  providedIn: 'root',
})
export class AppIdService {
  private readonly appIdExceptionMap = new Map<string, string>()

  constructor() {
    appIdExceptions.forEach((exception) => {
      this.appIdExceptionMap.set(exception.fileName, exception.appId)
    })
  }

  getAppId(appUrl: string): string {
    const urlParts = appUrl.split('/')
    const fileName = urlParts.at(-1)!.split('.')[0]
    const exceptionAppId = this.appIdExceptionMap.get(fileName)
    if (exceptionAppId) {
      return exceptionAppId
    }
    return fileName
  }
}
